import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 91716 166087"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:2382.98}.fil0{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970281371552">
        <path
          d="M90525 37906v53345L45858 54880 1191 91251V37906L45858 1537z"
          className="fill stroke1"
          style={{
            strokeWidth: 2382.98,
          }}
        />
        <path
          d="M90525 110189v17410L45858 91228 1191 127599v-17410l44667-36374z"
          className="fill stroke1"
          style={{
            strokeWidth: 2382.98,
          }}
        />
        <path
          d="M90525 146167v17413l-44667-36372-44667 36372v-17413l44667-36371z"
          className="fill stroke1"
          style={{
            strokeWidth: 2382.98,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
